<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <slot name="loader"></slot>
    <div
      v-if="showWriteReviewPopup"
      class="rfp-rr-ratings-write-review-178-or review-popup"
      :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
      style="display: block"
    >
      <div
        class="rfp-rr-ratings-write-review-179-or review-popup-close"
        :class="{ 'rfp-rr-rating-rtl-left': isRightToLeftActive }"
        @click="closePopup('yes')"
      >
        X
      </div>
      <form
        id="formId"
        class="rfp-rr-ratings-write-review-180-or"
        method="post"
        novalidate=""
        @submit.prevent="submit"
      >
        <div class="rfp-rr-ratings-write-review-181-or popup-inner">
          <div class="rfp-rr-ratings-write-review-182-or review-popup-header">
            <label v-html="headerTitle"></label>
          </div>
          <div class="rfp-rr-ratings-write-review-183-or review-popup-body">
            <div
              v-if="userText != ''"
              class="rfp-rr-ratings-write-review-241-or body-row full-width"
              :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
              v-html="userText"
            ></div>
            <div
              class="rfp-rr-ratings-write-review-184-or body-row overall-rating"
              :class="{ 'label-hide-show': !showLabelOverallRating }"
            >
              <div
                class="rfp-rr-ratings-write-review-185-or body-row-left"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                {{ labelOverallRating }}
              </div>
              <div
                class="rfp-rr-ratings-write-review-186-or body-row-right"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                <div class="rfp-rr-ratings-write-review-187-or stars">
                  <div class="rfp-rr-ratings-write-review-188-or star">
                    <vue-star-rating
                      :increment="starRatingIncrementValue"
                      :max-rating="starRatingMaxRatingValue"
                      :inactive-color="starRatingInactiveColor"
                      :active-color="starRatingActiveColor"
                      :star-size="starRatingStarSize"
                      :show-rating="false"
                      :rating="overallRating"
                      @rating-selected="overallRating = $event"
                      @update:rating="overallRating = $event"
                    >
                    </vue-star-rating>
                  </div>
                </div>
                <div
                  class="rfp-rr-ratings-write-review-189-or star-label"
                  :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
                >
                  <div v-if="overallRating === 1">
                    {{ starRatingOverallRatingDesc.one }}
                  </div>
                  <div v-else-if="overallRating === 2">
                    {{ starRatingOverallRatingDesc.two }}
                  </div>
                  <div v-else-if="overallRating === 3">
                    {{ starRatingOverallRatingDesc.three }}
                  </div>
                  <div v-else-if="overallRating === 4">
                    {{ starRatingOverallRatingDesc.four }}
                  </div>
                  <div v-else-if="overallRating === 5">
                    {{ starRatingOverallRatingDesc.five }}
                  </div>
                  <div v-else>
                    {{ starRatingOverallRatingDefault }}
                  </div>
                </div>
                <p
                  v-if="validation.firstError('overallRating')"
                  class="rfp-rr-ratings-write-review-190-or Refapp-ratings-validation-error rfp-ratings-specificAlignment"
                >
                  {{ overallRatingFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-191-or body-row full-width"
              :class="{ 'label-hide-show': !showLabelReviewTitle }"
            >
              <label
                for="rfp-rr-ratings-write-review-title"
                class="rfp-rr-ratings-write-review-192-or body-row-left"
              >
                {{ labelReviewTitle }}
              </label>
              <div class="rfp-rr-ratings-write-review-193-or body-row-right">
                <input
                  id="rfp-rr-ratings-write-review-title"
                  v-model="reviewTitle"
                  type="text"
                  :placeholder="reviewTitlePlaceholder"
                  :maxlength="reviewTitleMaxLength"
                  name="reviewTitle"
                />
                <p
                  v-if="validation.firstError('reviewTitle')"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ reviewTitleFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-195-or body-row full-width"
              :class="{ 'label-hide-show': !showLabelReview }"
            >
              <div class="rfp-rr-ratings-write-review-196-or body-row-left">
                {{ labelReview }}
              </div>
              <div class="rfp-rr-ratings-write-review-197-or body-row-right">
                <textarea
                  v-model="review"
                  class="rfp-rr-ratings-write-review-198-or ratings-review-font"
                  :placeholder="reviewPlaceholder"
                  :maxlength="reviewMaxLength"
                  name="review"
                ></textarea>
                <p
                  v-if="validation.firstError('review')"
                  class="rfp-rr-ratings-write-review-199-or Refapp-ratings-validation-error"
                >
                  {{ reviewFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-200-or body-row recommend"
              :class="{
                'label-hide-show': !showLabelWouldYouRecommendProductToFriend,
              }"
            >
              <div class="rfp-rr-ratings-write-review-201-or body-row-left">
                {{ labelProductRecommend }}
              </div>
              <div class="rfp-rr-ratings-write-review-202-or body-row-right">
                <label class="toggle-colors" for="recommend-toggle">
                  <input
                    id="recommend-toggle"
                    v-model="WouldYouRecommendThisProductToFriend"
                    type="checkbox"
                  />
                  <div
                    class="toggle"
                    :aria-checked="WouldYouRecommendThisProductToFriend"
                    :style="{
                      '--inactive-color': toggleButtonInactiveColor,
                      '--active-color': toggleButtonActiveColor,
                      '--toggle-yes': `'${toggleButtonActiveLabel}'`,
                      '--toggle-no': `'${toggleButtonInactiveLabel}'`,
                    }"
                  ></div>
                </label>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-235-or body-row"
              :class="{ 'label-hide-show': !userTypeShowHide }"
            >
              <div class="rfp-rr-ratings-write-review-236-or body-col">
                <div class="rfp-rr-ratings-write-review-237-or rfp-user-type-label body-row-left">
                  {{ userType }}
                </div>
              </div>
              <div class="rfp-rr-ratings-write-review-238-or body-col">
                <div class="rfp-rr-ratings-write-review-239-or body-row-right">
                  <select
                    id="userType"
                    v-model="userTypes"
                    class="rfp-rr-ratings-write-review-240-or"
                    name="userType"
                  >
                    <option value="">{{ dropDownSelectText }}</option>
                    <option v-for="x in userTypeDatas" :key="x" :value="x">{{ x }}</option>
                  </select>
                  <p
                    v-if="validation.firstError('userTypes')"
                    class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                  >
                    {{ userTypesFieldValidationMsg }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-204-or body-row"
              :class="{
                'label-hide-show': !showLabelLocation && !showLabelNickname,
              }"
            >
              <div
                class="rfp-rr-ratings-write-review-205-or"
                :class="{
                  'label-hide-show': !showLabelNickname,
                  ' body-col': showLabelLocation,
                }"
              >
                <div class="rfp-rr-ratings-write-review-206-or body-row-left">
                  {{ labelNickname }}
                </div>
                <div class="rfp-rr-ratings-write-review-207-or body-row-right">
                  <input
                    v-model="nickname"
                    :placeholder="nicknamePlaceholder"
                    :maxlength="nicknameMaxLength"
                    name="nickname"
                    type="text"
                  />
                  <p
                    v-if="validation.firstError('nickname')"
                    class="rfp-rr-ratings-write-review-208-or Refapp-ratings-validation-error"
                  >
                    {{ nicknameFieldValidationMsg }}
                  </p>
                </div>
              </div>
              <div
                class="rfp-rr-ratings-write-review-209-or"
                :class="{
                  'label-hide-show': !showLabelLocation,
                  ' body-col': showLabelNickname,
                }"
              >
                <div class="rfp-rr-ratings-write-review-210-or body-row-left">
                  {{ labelLocation }}
                </div>
                <div class="rfp-rr-ratings-write-review-211-or body-row-right">
                  <input
                    v-model="location"
                    :placeholder="locationPlaceholder"
                    :maxlength="locationMaxLength"
                    name="location"
                    type="text"
                  />
                  <p
                    v-if="validation.firstError('location')"
                    class="rfp-rr-ratings-write-review-212-or Refapp-ratings-validation-error"
                  >
                    {{ locationFieldValidationMsg }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-213-or body-row"
              :class="{
                'label-hide-show': !showHowOldAreYou && !showLabelEmail,
              }"
            >
              <div
                class="rfp-rr-ratings-write-review-214-or"
                :class="{
                  'label-hide-show': !showLabelEmail,
                  'body-col': showHowOldAreYou,
                }"
              >
                <div class="rfp-rr-ratings-write-review-215-or body-row-left">
                  {{ labelEmail }}
                </div>
                <div class="rfp-rr-ratings-write-review-216-or body-row-right">
                  <input v-model="emailStatus" :placeholder="emailPlaceholder" type="text" />
                  <p
                    v-if="validation.firstError('emailStatus')"
                    class="rfp-rr-ratings-write-review-217-or Refapp-ratings-validation-error"
                  >
                    {{ emailFieldValidationMsg }}
                  </p>
                </div>
              </div>
              <div
                class="rfp-rr-ratings-write-review-218-or"
                :class="{
                  'label-hide-show': !showHowOldAreYou,
                  'body-col': showLabelEmail,
                }"
              >
                <div class="rfp-rr-ratings-write-review-219-or body-row-left">
                  {{ labelHowOldAreYou }}
                </div>
                <div class="rfp-rr-ratings-write-review-220-or body-row-right">
                  <select
                    id="AgeList"
                    v-model="AgeRange"
                    class="rfp-rr-ratings-write-review-221-or"
                    name="AgeRange"
                  >
                    <option value="">{{ dropDownSelectText }}</option>
                    <option v-for="x in howOldAreYouInputValue" :key="x" :value="x">{{ x }}</option>
                  </select>
                  <p
                    v-if="validation.firstError('AgeRange')"
                    class="rfp-rr-ratings-write-review-212-a-or Refapp-ratings-validation-error"
                  >
                    {{ ageRangeFieldValidationMsg }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-222-or body-row quality"
              :class="{
                'label-hide-show': !showHowWouldYouRateThisQualityOfThisProduct,
              }"
            >
              <div
                class="rfp-rr-ratings-write-review-223-or body-row-left"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                {{ labelHowWouldYouRateThisQualityOfThisProduct }}
              </div>
              <div class="rfp-rr-ratings-write-review-224-or body-row-right">
                <div class="rfp-rr-ratings-write-review-225-or stars">
                  <div
                    class="rfp-rr-ratings-write-review-226-or star"
                    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                  >
                    <vue-star-rating
                      :increment="starRatingIncrementValue"
                      :max-rating="starRatingMaxRatingValue"
                      :inactive-color="starRatingInactiveColor"
                      :active-color="starRatingActiveColor"
                      :star-size="starRatingStarSize"
                      :show-rating="false"
                      :rating="HowWouldYouRateThisQualityOfThisProduct"
                      @rating-selected="HowWouldYouRateThisQualityOfThisProduct = $event"
                      @update:rating="HowWouldYouRateThisQualityOfThisProduct = $event"
                    >
                    </vue-star-rating>
                  </div>
                </div>
                <div class="rfp-rr-ratings-write-review-227-or star-label">
                  <div v-if="HowWouldYouRateThisQualityOfThisProduct === 1">
                    {{ howWouldYouRateThisQualityOfThisProductDesc.one }}
                  </div>
                  <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 2">
                    {{ howWouldYouRateThisQualityOfThisProductDesc.two }}
                  </div>
                  <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 3">
                    {{ howWouldYouRateThisQualityOfThisProductDesc.three }}
                  </div>
                  <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 4">
                    {{ howWouldYouRateThisQualityOfThisProductDesc.four }}
                  </div>
                  <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 5">
                    {{ howWouldYouRateThisQualityOfThisProductDesc.five }}
                  </div>
                  <div v-else>
                    {{ howWouldYouRateThisQualityOfThisProductDefault }}
                  </div>
                </div>
                <p
                  v-if="validation.firstError('HowWouldYouRateThisQualityOfThisProduct')"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ qualityOfThisProductFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-222-or body-row quality"
              :class="{ 'label-hide-show': !showLabelYesOrNoRadio }"
            >
              <div
                class="rfp-rr-ratings-write-review-223-or body-row-left"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                {{ yesOrNoRadioButtonLabelText }}
              </div>
              <div class="rfp-rr-ratings-write-review-224-or body-row-left">
                <label for="sample-yes" class="rfp-rr-ratings-radio-label">
                  <input id="sample-yes" v-model="yesOrNoRadioValue" type="radio" value="true" />
                  {{ yesRadioButtonLabelText }}
                </label>
                <label for="sample-no" class="rfp-rr-ratings-radio-label">
                  <input id="sample-no" v-model="yesOrNoRadioValue" type="radio" value="false" />
                  {{ noRadioButtonLabelText }}
                </label>
                <p
                  v-if="validation.firstError('yesOrNoRadioValue')"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ yesOrNoRadioButtonValidationMsg }}
                </p>
              </div>
            </div>
            <rfp-ratings-write-optional-select
              v-if="
                fields.howDidYouHearAboutTheProductLabelShowHide &&
                fields.howDidYouHearAboutTheProductDatas?.length
              "
              id="howDidYouHearAboutTheProduct"
              :label="fields.howDidYouHearAboutTheProductLabel"
              :default-option="dropDownSelectText"
              :options="fields.howDidYouHearAboutTheProductDatas"
              :validation-error="validation.firstError('howDidYouHearAboutTheProduct')"
              :validation-error-message="fields.howDidYouHearAboutTheProductFieldValidationMsg"
              @update="howDidYouHearAboutTheProduct = $event"
            ></rfp-ratings-write-optional-select>
            <rfp-ratings-write-optional-select
              v-if="fields.genderLabelShowHide && fields.genderValueDatas?.length"
              id="userGender"
              :label="fields.genderLabel"
              :default-option="dropDownSelectText"
              :options="fields.genderValueDatas"
              :validation-error="validation.firstError('genderValue')"
              :validation-error-message="fields.genderValidationMsg"
              @update="genderValue = $event"
            ></rfp-ratings-write-optional-select>
            <rfp-ratings-write-optional-stars
              v-if="
                fields.effectivenessOfTheProductLabelShowHide &&
                fields.effectivenessOfTheProduct instanceof Object &&
                Object.keys(fields.effectivenessOfTheProduct).length > 0
              "
              :label="fields.effectivenessOfTheProductLabel"
              :options="fields.effectivenessOfTheProduct"
              :validation-error="validation.firstError('effectivenessOfTheProduct')"
              :validation-error-message="fields.effectivenessOfTheProductValidationMsg"
              :rtl="isRightToLeftActive"
              :value="effectivenessOfTheProduct"
              @update="effectivenessOfTheProduct = $event"
            ></rfp-ratings-write-optional-stars>
            <rfp-ratings-write-optional-stars
              v-if="
                fields.textureOfTheProductLabelShowHide &&
                fields.textureOfTheProduct instanceof Object &&
                Object.keys(fields.textureOfTheProduct).length > 0
              "
              :label="fields.textureOfTheProductLabel"
              :options="fields.textureOfTheProduct"
              :validation-error="validation.firstError('textureOfTheProduct')"
              :validation-error-message="fields.textureOfTheProductValidationMsg"
              :rtl="isRightToLeftActive"
              :value="textureOfTheProduct"
              @update="textureOfTheProduct = $event"
            ></rfp-ratings-write-optional-stars>
            <rfp-ratings-write-optional-stars
              v-if="
                fields.pricePositionOfTheProductLabelShowHide &&
                fields.pricePositionOfTheProduct instanceof Object &&
                Object.keys(fields.pricePositionOfTheProduct).length > 0
              "
              :label="fields.pricePositionOfTheProductLabel"
              :options="fields.effectivenessOfTheProduct"
              :validation-error="validation.firstError('pricePositionOfTheProduct')"
              :validation-error-message="fields.pricePositionOfTheProductValidationMsg"
              :rtl="isRightToLeftActive"
              :value="pricePositionOfTheProduct"
              @update="pricePositionOfTheProduct = $event"
            ></rfp-ratings-write-optional-stars>
            <div
              class="rfp-rr-ratings-write-review-228-or body-row full-width"
              :class="{
                'label-hide-show': !showLabelWouldYouRecommendThisProductToFriend,
              }"
            >
              <div class="body-row-left">
                {{ labelWouldYouRecommendThisProductToFriend }}
              </div>
              <div class="rfp-rr-ratings-write-review-229-or body-row-right">
                <div class="rfp-rr-ratings-write-review-230-or recommend-slider">
                  <vue-slider
                    id="custom-tooltip"
                    v-bind="rangeSliderConfig"
                    v-model="wouldYouRecommendMaybellineToFriend"
                    name="wouldYouRecommendMaybellineToFriend"
                    :recommend-to-friend-rating-scale="recommendToFriendRatingScale"
                  ></vue-slider>
                </div>
                <p
                  v-if="validation.firstError('wouldYouRecommendMaybellineToFriend')"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ recommendProductToFriendFieldValidationMsg }}
                </p>
              </div>
            </div>
            <div v-if="imageUpload.Active" class="body-row full-width">
              <rfp-ratings-upload-image
                :config="imageUpload.Config"
                :dictionary="imageUpload.ImageUploadDictionary"
              ></rfp-ratings-upload-image>
            </div>
            <div
              class="rfp-rr-ratings-write-review-231-or checkboxes body-row form-terms-use"
              :class="{
                'label-hide-show': !showLabelTermsOfUse,
                'rfp-rr-rating-rtl-float-right': isRightToLeftActive,
              }"
            >
              <label
                for="rfp-rr-ratings-write-review-terms"
                class="rfp-rr-ratings-write-review-232-or mobile-terms"
                :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
              >
                <input
                  id="rfp-rr-ratings-write-review-terms"
                  v-model="termsOfUse"
                  type="checkbox"
                  class="rfp-rr-ratings-write-review-233-or checkbox--rr-design"
                  :class="{ 'rfp-rr-rating-rtl-right': isRightToLeftActive }"
                />
                <p
                  class="form-terms-use__description"
                  :class="{
                    error__text__red: validation.firstError('termsOfUse'),
                    'rfp-rr-rating-rtl-write-review-tearms': isRightToLeftActive,
                  }"
                  v-html="labelTermsOfUseStepOne"
                ></p>
              </label>
            </div>
            <div
              v-for="e in errors"
              :key="e"
              class="body-row Refapp-ratings-validation-error"
              v-text="e"
            ></div>
            <div class="rfp-rr-ratings-write-review-234-or body-row action-row">
              <input
                type="submit"
                :disabled="submitting"
                :value="reviewButtonText"
                class="button button-primary"
                :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import VueSlider from 'vue-slider-component';
import SimpleVueValidation from 'simple-vue-validator';
import VueStarRating from 'vue-star-rating';
import axios from 'axios';
import RfpRatingsUploadImage from '../rfp-ratings-upload-images/rfp-ratings-upload-image.vue';
import RfpRatingsWriteOptionalSelect from './rfp-ratings-write-optional-select.vue';
import RfpRatingsWriteOptionalStars from './rfp-ratings-write-optional-stars.vue';

const Validator = SimpleVueValidation.Validator;
const RATINGS_REVIEWS_BODY_CLASS = 'rare-custom-body-class';
const ENABLE_LOADING_EVENT = 'rfp-common-loading-enable';

export default {
  name: 'rfp-ratings-write-review',
  components: {
    VueSlider,
    VueStarRating,
    RfpRatingsUploadImage,
    RfpRatingsWriteOptionalSelect,
    RfpRatingsWriteOptionalStars,
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      increment: this.$props.starRatingIncrementValue,
      maxRating: this.$props.starRatingMaxRatingValue,
      inactiveColor: this.$props.starRatingInactiveColor,
      activeColor: this.$props.starRatingActiveColor,
      starSize: this.$props.starRatingStarSize,
    };
  },
  props: {
    imageUpload: {
      type: Object,
      required: false,
      default() {
        return {
          Active: true,
        };
      },
    },
    action: {
      type: String,
      required: true,
    },
    headerTitle: {
      type: String,
      required: true,
    },
    userText: {
      type: String,
      required: true,
    },
    languageName: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
    labelOverallRating: {
      type: String,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    toggleButtonActiveColor: {
      type: String,
      default: '#FB2460',
    },
    toggleButtonInactiveColor: {
      type: String,
      default: '#EEE',
    },
    toggleButtonActiveLabel: {
      type: String,
      default: 'Y',
    },
    toggleButtonInactiveLabel: {
      type: String,
      default: 'N',
    },
    starRatingOverallRatingDesc: {
      type: Object,
      required: true,
    },
    starRatingOverallRatingDefault: {
      type: String,
      default: 'Click to rate!',
    },
    overallRatingFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelReviewTitle: {
      type: String,
      required: true,
    },
    reviewTitlePlaceholder: {
      type: String,
      required: true,
    },
    reviewTitleFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelReview: {
      type: String,
      required: true,
    },
    reviewPlaceholder: {
      type: String,
      required: true,
    },
    reviewFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelNickname: {
      type: String,
      required: true,
    },
    nicknamePlaceholder: {
      type: String,
      required: true,
    },
    nicknameFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelLocation: {
      type: String,
      required: true,
    },
    locationPlaceholder: {
      type: String,
      required: true,
    },
    locationFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelEmail: {
      type: String,
      required: true,
    },
    emailPlaceholder: {
      type: String,
      required: true,
    },
    emailFieldValidationMsg: {
      type: String,
      required: true,
    },
    labelWouldYouRecommendThisProductToFriend: {
      type: String,
      required: true,
    },
    labelTermsOfUseStepOne: {
      type: String,
      required: true,
    },
    showLabelOverallRating: {
      type: Boolean,
      default: false,
    },
    showLabelReviewTitle: {
      type: Boolean,
      default: false,
    },
    showLabelReview: {
      type: Boolean,
      default: false,
    },
    showLabelNickname: {
      type: Boolean,
      default: false,
    },
    showLabelLocation: {
      type: Boolean,
      default: false,
    },
    showLabelEmail: {
      type: Boolean,
      default: false,
    },
    showLabelWouldYouRecommendThisProductToFriend: {
      type: Boolean,
      default: true,
    },
    showLabelTermsOfUse: {
      type: Boolean,
      default: false,
    },
    labelHowOldAreYou: {
      type: String,
      required: true,
    },
    showHowOldAreYou: {
      type: Boolean,
      default: false,
    },
    showLabelWouldYouRecommendProductToFriend: {
      type: Boolean,
      default: false,
    },
    labelHowWouldYouRateThisQualityOfThisProduct: {
      type: String,
      required: true,
    },
    showHowWouldYouRateThisQualityOfThisProduct: {
      type: Boolean,
      default: false,
    },
    howWouldYouRateThisQualityOfThisProductDesc: {
      type: Object,
      required: true,
    },
    howWouldYouRateThisQualityOfThisProductDefault: {
      type: String,
      required: true,
    },
    howOldAreYouInputValue: {
      type: Array,
      required: true,
    },
    productItemId: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    reviewTitleMaxLength: {
      type: Number,
      required: true,
    },
    reviewMaxLength: {
      type: Number,
      required: true,
    },
    nicknameMaxLength: {
      type: Number,
      required: true,
    },
    locationMaxLength: {
      type: Number,
      required: true,
    },
    signinNickname: {
      type: String,
      required: false,
    },
    signinLocation: {
      type: String,
      required: false,
    },
    signinEmail: {
      type: String,
      required: false,
    },
    labelProductRecommend: {
      type: String,
      required: true,
    },
    userTypeDatas: {
      type: Array,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
    userTypeShowHide: {
      type: Boolean,
      required: true,
    },
    reviewButtonText: {
      type: String,
      default: 'Post Review',
    },
    dropDownSelectText: {
      type: String,
      default: 'Post Review',
    },
    recommendToFriendRatingScale: {
      type: Number,
      required: true,
    },
    overallRatingValidation: {
      type: Boolean,
      default: true,
    },
    reviewTitleValidation: {
      type: Boolean,
      default: true,
    },
    reviewValidation: {
      type: Boolean,
      default: true,
    },
    nicknameValidation: {
      type: Boolean,
      default: true,
    },
    locationValidation: {
      type: Boolean,
      default: true,
    },
    emailValidation: {
      type: Boolean,
      default: true,
    },
    ageRangeValidation: {
      type: Boolean,
      default: true,
    },
    ageRangeFieldValidationMsg: {
      type: String,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    isRecommendRatingOptionalValidation: {
      type: Boolean,
      default: true,
    },
    howWouldYouRateThisQualityOfThisProductValidation: {
      type: Boolean,
      default: true,
    },
    isRecommendOptionalValidation: {
      type: Boolean,
      default: true,
    },
    userTypeValidation: {
      type: Boolean,
      default: true,
    },
    userTypesFieldValidationMsg: {
      type: String,
      default: 'User type required',
    },
    qualityOfThisProductFieldValidationMsg: {
      type: String,
      default: 'Quality of product required',
    },
    recommendProductToFriendFieldValidationMsg: {
      type: String,
      default: 'Recommend to a friend required',
    },
    yesOrNoRadioButtonLabelText: {
      type: String,
      default: 'Hai ricevuto un campione gratuito di questo prodotto?',
    },
    yesOrNoRadioButtonValidationMsg: {
      type: String,
      default: 'Required',
    },
    yesOrNoRadioCmsValidation: {
      type: Boolean,
      default: true,
    },
    showLabelYesOrNoRadio: {
      type: Boolean,
      default: true,
    },
    yesRadioButtonLabelText: {
      type: String,
      default: 'Yes',
    },
    noRadioButtonLabelText: {
      type: String,
      default: 'No',
    },
    utmParameters: {
      type: Object,
      default() {
        return { UtmSource: '', UtmCampaign: '', UtmMedium: '' };
      },
    },
    fields: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    /* istanbul ignore next */
    return {
      rangeSliderConfig: {
        show: true,
        value: 0,
        min: 0,
        max: this.recommendToFriendRatingScale,
        marks: true,
        tooltip: 'always',
      },
      termsOfUse: false,
      testValidation: '',
      overallRating: 0,
      overallRatings: 0,
      HowWouldYouRateThisQualityOfThisProduct: 0,
      WouldYouRecommendThisProductToFriend: false,
      reviewTitle: '',
      review: '',
      nickname: this.signinNickname ? this.signinNickname : '',
      location: this.signinLocation ? this.signinLocation : '',
      emailStatus: this.signinEmail ? this.signinEmail : '',
      wouldYouRecommendMaybellineToFriend: 0,
      AgeRange: '',
      showWriteReviewPopup: false,
      userTypes: '',
      activeSlider: false,
      submitting: false,
      vueSliderRtl: 'ltr',
      yesOrNoRadioValue: '',
      // addon fields
      howDidYouHearAboutTheProduct: '',
      genderValue: '',
      effectivenessOfTheProduct: 0,
      textureOfTheProduct: 0,
      pricePositionOfTheProduct: 0,
      // end addon fields
      toggleButtonColor: {
        checked: this.toggleButtonActiveColor,
        unchecked: this.toggleButtonInactiveColor,
      },
      toggleButtonLabels: {
        checked: this.toggleButtonActiveLabel,
        unchecked: this.toggleButtonInactiveLabel,
      },
      getUtmParameterDatas: {},
      errors: [],
    };
  },
  validators: {
    overallRating(value) {
      /* istanbul ignore next */
      if (!this.overallRatingValidation) {
        return Validator.value(value).required();
      }
      return Validator.value(value);
    },
    reviewTitle(value) {
      /* istanbul ignore next */
      if (!this.reviewTitleValidation) {
        return Validator.value(value).required().maxLength(this.reviewTitleMaxLength);
      }
      return Validator.value(value);
    },
    review(value) {
      /* istanbul ignore next */
      if (!this.reviewValidation) {
        return Validator.value(value).required().maxLength(this.reviewMaxLength);
      }
      return Validator.value(value);
    },
    nickname(value) {
      /* istanbul ignore next */
      if (!this.nicknameValidation) {
        return Validator.value(value).required().maxLength(this.nicknameMaxLength);
      }
      return Validator.value(value);
    },
    location(value) {
      /* istanbul ignore next */
      if (!this.locationValidation) {
        return Validator.value(value).required().maxLength(this.locationMaxLength);
      }
      return Validator.value(value);
    },
    AgeRange(value) {
      /* istanbul ignore next */
      if (this.ageRangeValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    emailStatus(value) {
      /* istanbul ignore next */
      if (this.emailValidation) {
        return Validator.value(value).email();
      }
      return Validator.value(value).required().email();
    },
    termsOfUse(value) {
      this.termsOfUse = value || '';
      return Validator.value(value).required();
    },
    WouldYouRecommendThisProductToFriend(value) {
      /* istanbul ignore next */
      if (this.isRecommendOptionalValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    HowWouldYouRateThisQualityOfThisProduct(value) {
      /* istanbul ignore next */
      if (!this.howWouldYouRateThisQualityOfThisProductValidation) {
        return Validator.value(value).required().greaterThanOrEqualTo(1);
      }
      return Validator.value(value);
    },
    wouldYouRecommendMaybellineToFriend(value) {
      /* istanbul ignore next */
      if (!this.isRecommendRatingOptionalValidation) {
        return Validator.value(value).required().minLength(1);
      }
      return Validator.value(value);
    },
    userTypes(value) {
      /* istanbul ignore next */
      if (this.userTypeValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    yesOrNoRadioValue(value) {
      /* istanbul ignore next */
      if (this.yesOrNoRadioCmsValidation) {
        return Validator.value(value);
      }
      return Validator.value(value).required();
    },
    // optional field validators
    howDidYouHearAboutTheProduct(value) {
      // logic is inverted because OF COURSE IT IS! FALSE means it SHOULD be validated
      if (
        this.fields.howDidYouHearAboutTheProductValidation === false &&
        this.fields.howDidYouHearAboutTheProductDatas?.length
      ) {
        return Validator.value(value).required();
      }
      return Validator.value(value);
    },
    genderValue(value) {
      if (this.fields.genderValidation === false && this.fields.genderValueDatas?.length) {
        return Validator.value(value).required();
      }
      return Validator.value(value);
    },
    effectivenessOfTheProduct(value) {
      if (
        this.fields.effectivenessOfTheProductValidation === false &&
        this.fields.effectivenessOfTheProduct instanceof Object &&
        Object.keys(this.fields.effectivenessOfTheProduct).length
      ) {
        // using this validator enables keeping the same numeric type for the value
        // instead of relying on an initial value of ''
        return Validator.value(value).integer().greaterThan(0);
      }
      return Validator.value(value);
    },
    textureOfTheProduct(value) {
      if (
        this.fields.textureOfTheProductValidation === false &&
        this.fields.textureOfTheProduct instanceof Object &&
        Object.keys(this.fields.textureOfTheProduct).length
      ) {
        return Validator.value(value).integer().greaterThan(0);
      }
      return Validator.value(value);
    },
    pricePositionOfTheProduct(value) {
      if (
        this.fields.pricePositionOfTheProductValidation === false &&
        this.fields.pricePositionOfTheProduct instanceof Object &&
        Object.keys(this.fields.pricePositionOfTheProduct).length
      ) {
        return Validator.value(value).integer().greaterThan(0);
      }
      return Validator.value(value);
    },
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('show-write-review', () => {
      document.body.classList.add(RATINGS_REVIEWS_BODY_CLASS);
      this.showWriteReviewPopup = true;
      this.activeSlider = true;
    });
    /* istanbul ignore next */
    eventBus.on('activeSliderWriteReview', () => {
      this.activeSlider = false;
    });
    this.getUtmParameters();
  },
  mounted() {
    eventBus.emit(ENABLE_LOADING_EVENT, true);
  },
  methods: {
    closePopup(values) {
      this.showWriteReviewPopup = false;
      this.activeSlider = false;
      document.body.classList.remove(RATINGS_REVIEWS_BODY_CLASS);
      eventBus.emit('ScrollTrue');
      /* istanbul ignore next */
      if (values === 'yes') {
        this.validation.reset();
      }
    },
    getUtmParameters(args) {
      if (args === '') return;
      return new URLSearchParams(window.location.search).get(args);
    },
    submit() {
      /* istanbul ignore next */
      if (this.overallRating === 0) {
        this.overallRating = '';
      }
      /* istanbul ignore next */
      this.$validate().then((isFormValid) => {
        if (isFormValid && this.termsOfUse && !this.submitting) {
          this.submitting = true; // block the interface
          if (this.nickname === '') {
            this.nickname = 'Anonymous';
          }
          const datas = {
            Images: window.imgStorage ? window.imgStorage : [],
            ReviewTitle: this.reviewTitle,
            ReviewContent: this.review,
            NickName: this.nickname,
            Location: this.location,
            Email: this.emailStatus,
            AgeRange: this.AgeRange,
            ProductRating: this.overallRating,
            QualityRating: this.HowWouldYouRateThisQualityOfThisProduct,
            IsRecommend: this.WouldYouRecommendThisProductToFriend,
            RecommendRating: this.wouldYouRecommendMaybellineToFriend,
            productItemId: this.productItemId,
            productId: this.productId,
            languageName: this.languageName,
            productName: this.productName,
            languageCode: this.languageCode,
            UserType: this.userTypes,
            IsProductGivenFree: this.yesOrNoRadioValue,
            UtmSource: this.getUtmParameters(this.utmParameters.UtmSource),
            UtmCampaign: this.getUtmParameters(this.utmParameters.UtmCampaign),
            UtmMedium: this.getUtmParameters(this.utmParameters.UtmMedium),
            // New Fields
            ProductVoice: this.howDidYouHearAboutTheProduct,
            Gender: this.genderValue,
            EffectivenessRating: this.effectivenessOfTheProduct,
            TextureRating: this.textureOfTheProduct,
            PricePositionRating: this.pricePositionOfTheProduct,
          };
          eventBus.emit(ENABLE_LOADING_EVENT, true);
          axios
            .post(this.action, {
              formData: datas,
            })
            .then((response) => {
              if (response.data.Message === 'Success') {
                eventBus.emit('PostReviewTags', this.overallRating);
                this.showWriteReviewPopup = false;
                eventBus.emit('showSuccessReview');
              } else {
                this.showWriteReviewPopup = false;
                eventBus.emit('show-review-warning');
              }
              this.reviewTitle = '';
              this.review = '';
              this.nickname = '';
              this.location = '';
              this.emailStatus = '';
              this.AgeRange = '';
              this.userTypes = '';
              this.overallRating = 0;
              this.HowWouldYouRateThisQualityOfThisProduct = 0;
              this.WouldYouRecommendThisProductToFriend = false;
              this.wouldYouRecommendMaybellineToFriend = '';
              this.termsOfUse = false;
              this.validation.reset();
              this.activeSlider = false;
              document.body.classList.remove(RATINGS_REVIEWS_BODY_CLASS);
            })
            .catch((e) => {
              // TODO: log errors instead and display a user friendly failure message
              this.errors.push(e);
            })
            .finally(() => {
              // this event controls the loader instance
              eventBus.emit(ENABLE_LOADING_EVENT, false);
              this.submitting = false; // unblock the interface
            });
        }
      });
      /* istanbul ignore next */
      if (this.overallRating === '') {
        this.overallRating = 0;
      }
    },
  },
};
</script>
